import React, { Component } from 'react'
import { connect } from 'react-redux'
import { switchUniqueVotes } from '../../../actions'

class PollsStats extends Component {
  render () {
    const { polls } = this.props
    let votes = []
    polls.forEach(poll => {
      votes = poll.votes ? votes.concat(poll.votes) : votes
    })
    const participants = votes.length > 0 ? [...new Set(votes.map(v => v.participant))] : []

    return [
      <div className='dashboard-teams-row' key='0'>
        <div className='cell-subject' >-----------------------</div>
      </div>,
      <div className='dashboard-teams-row' key='1'>
        <div className='cell-subject'>Polls</div>
        <div className='cell-tags cell-looking-for'>
          {polls.length}
        </div>
      </div>,
      <div className='dashboard-teams-row' key='2'>
        <div className='cell-subject unset-text-transform'>Nulber of participants</div>
        <div className='cell-tags cell-looking-for'>
          {participants.length}
        </div>
      </div>,
      <div className='dashboard-teams-row' key='3'>
        <div className='cell-subject unset-text-transform'>Number of unique votes</div>
        <div className='cell-tags cell-looking-for'>
          {votes.length}
        </div>
        <div className='cell-team admin-tab-cell'>
          <button
            onClick={() => this.props.dispatch(switchUniqueVotes(votes))}
            className='button button-sm'>View all unique votes</button>
        </div>
      </div>
    ]
  }
}

const mapStateToProps = (state) => {
  return {
    polls: state.comments.polls
  }
}

export default connect(mapStateToProps)(PollsStats)



// WEBPACK FOOTER //
// ./src/screens/administration/statistics/PollsStats.js